import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, Input } from '@angular/core';
import { CallCenterService } from 'src/app/services/call-center.service';
import { AskApolloService } from 'src/app/services/ask-apollo.service';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MessageServiceService } from 'src/app/services/message-service.service';
import { compareAsc } from 'date-fns';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CalendarUtilityService } from 'src/app/services/calendar-utility.service';
import { HealthCheckService } from 'src/app/services/health-check.service';
import { CommonMethods } from 'src/app/shared/CommonMethods';
@Component({
  selector: 'app-ask-apollo-hcappointments-history',
  templateUrl: './ask-apollo-hcappointments-history.component.html',
  styleUrls: ['./ask-apollo-hcappointments-history.component.scss']
})
export class AskApolloHCAppointmentsHistoryComponent implements OnInit {

  confirmModalRef: BsModalRef;
  @ViewChild('hcPopupTemplate', { static: false }) hcPopupTemplate: TemplateRef<any>;
  appointmentsHistory = [];
  isLoading: boolean = false
  callHistoryIsLoading: boolean = false
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  }
  modalTitle: string = "";
  selectedApptDetails;
  constructor(private callCenterService: CallCenterService,
    private askApolloService: AskApolloService,
    private messageService: MessageServiceService,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private hcService: HealthCheckService,
    private calendarService: CalendarUtilityService,
    private router: Router,) { }

  @Input() currentMobileNumber = '';
  rescheduleAppointmentForm: FormGroup;
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;
  ngOnInit() {
    this.rescheduleAppointmentForm = this.formBuilder.group({
      appointmentDate: ['', Validators.required],
      appointmentSlot: ['',[Validators.required, Validators.min(1)]],
      statusRemarks:['']
    });
    this.getAppointmentsHistoryOnMobileNumberFromAskApollo(this.currentMobileNumber);
  }



  rescheduleDetails=[];
  isCancel: boolean = false;
  showModalDialog(apptDetails, type) {
    this.confirmModalRef = this.modalService.show(this.hcPopupTemplate, Object.assign({}, this.config, { class: 'gray modal-lg modal-dialog-centered' }));
    this.rescheduleDetails  =[];
    this.rescheduleDetails = apptDetails;
    if (type == "cancel") {
      this.modalTitle = "Cancel Appointment";
      this.isCancel = true
      this.selectedHospital = this.rescheduleDetails['HospitalId'];
    }
    else {
      this.modalTitle = "Reschedule Appointment";
      this.isCancel = false
      this.getAppointmentDetails();
    }
  }

  closeConfirmModal() {
    this.confirmModalRef.hide();
  }

 
  getAppointmentDetails(){
      this.selectedHospital = this.rescheduleDetails['HospitalId'];
      this.selectedHC = this.rescheduleDetails['HealthCheckId'];      
      this.previousApptDate = this.rescheduleDetails['AppointmentDate'];
      
      this.getDates();
  }

  selectedDate;
  previousApptDate;
  selectedHospital;
  selectedDoctor;
  selectedHC;
  getDates(){         
    this.loadingFlag = true;
    this.datesData =[];
    let data = {
      "hospitalId": +this.selectedHospital,//+this.selectedHospital,
      "healthCheckId": +this.selectedHC
    }

    this.hcService.getHealthCheckDates(data)  // hospitalid, doctorId
    .subscribe((res: any) => {
      if(res.name && res.name.length > 0){
        this.disableApptDates(res.name);
      }
      this.loadingFlag = false;
    }, error => {
      this.loadingFlag = false;
      this.messageService.showErrorMessage("Unable to retrieve appt dates data from server ");
    })
  }

  datesData: any[];
  apptMaximumDate = new Date();
  apptMinimumDate = new Date();
  invalidApptDates: Date[];
  tempDates: Date[];
  disableApptDates(enableDates) {
    //enableDates = "2020-5-14,2020-5-18,2020-5-19,2020-5-20,2020-5-21,2020-5-25,2020-5-26,2020-5-27,2020-5-30,2020-6-1,2020-6-2,2020-6-3,2020-6-4,2020-6-5,2020-6-6,2020-6-11,2020-6-12,2020-6-13,2020-6-15,2020-6-16,2020-6-19,2020-6-20,2020-6-22,2020-6-23,2020-6-24,2020-6-25,2020-6-26,2020-6-27,2020-6-29,2020-6-30,2020-7-1,2020-7-2,2020-7-3,2020-7-4,2020-7-6,2020-7-7,2020-7-8,2020-7-9,2020-7-10,2020-7-11,2020-7-13,2020-7-14,2020-7-15,2020-7-16,2020-7-17,2020-7-18,2020-7-20,2020-7-21,2020-7-22,2020-7-23,2020-7-24,2020-7-25,2020-7-27,2020-7-28,2020-7-29,2020-7-30,2020-7-31,2020-8-1,2020-8-3,2020-8-4,2020-8-5,2020-8-6,2020-8-7,2020-8-8,2020-8-14,2020-8-15,2020-8-17,2020-8-18,2020-8-19,2020-8-20,2020-8-21,2020-8-22,2020-8-24,2020-8-29,2020-8-31";
    this.invalidApptDates = [];
    this.apptMaximumDate = new Date();
    this.apptMinimumDate = new Date();
    this.datesData = enableDates ? enableDates.split(",") : [];
    let tempDates = [];
    debugger
    for(let i =0;i< this.datesData.length;i++){
        let dArr = this.datesData[i].split("/")
        let dd = dArr[2]+"-"+dArr[1]+"-"+dArr[0];
        tempDates.push(dd);
    }
    this.datesData = tempDates;
    if (this.datesData.length > 0) {
      this.datesData.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
      this.apptMaximumDate = new Date(this.datesData[this.datesData.length - 1]);
      this.apptMinimumDate = new Date(this.datesData[0]);
      this.tempDates =[];
      this.datesData.forEach(d => {
          this.tempDates.push(new Date(d))
      });
    
      this.invalidApptDates = this.calendarService.getDisabledDates(this.tempDates);
    
      //this.ref.detectChanges();
    } else {
      this.invalidApptDates =[];
    }
  }
  slotsData;
  allSlotsData=[];
  loadingFlag:boolean = false;
  getSlots(apptDate){
    this.loadingFlag = true;
    this.allSlotsData =[];
    this.rescheduleAppointmentForm.get('appointmentSlot').setValue('');
    let dd = new Date(apptDate);
    let date = dd.getDate();
    let month = (dd.getMonth() + 1)+"";
    let year = dd.getFullYear();
    apptDate = date+'-'+(month.length == 1 ? '0'+month : month)+'-'+year; 
    
    
    let data = {
      "hospitalId": +this.selectedHospital,
      "healthCheckId": Number(this.selectedHC),
      "appointmentDate": apptDate
    };

    this.hcService.getHealthCheckSlots(data) 
    .subscribe((res: any) => {
    
        this.slotsData = res.response;
        
        if(res.hcSlots && res.hcSlots.length >0)
          this.allSlotsData = res.hcSlots;

        if(this.allSlotsData.length ==0){
          this.messageService.showErrorMessage("No slots available on selected date.");
        }        
        this.loadingFlag =false;
    }, error => {
      if(error.status ==400){
        this.messageService.showErrorMessage(error.error.Message);
      }else{
        this.messageService.showErrorMessage("Unable to load slots from server");
      }
      this.loadingFlag = false;
      
    })
  }

  changeAskApolloDateFormatDDMMYYYY(givenDate) {
    let d = givenDate.split(" ")[0]
    return d.replaceAll("-", "/")
  }

  RescheduleAppointment(){    
    /** check form */
    
    let formDataValues =this.rescheduleAppointmentForm.value;
    let slotObj = this.allSlotsData.find(o => o.SlotId == formDataValues.appointmentSlot);
    //debugger
    let payload = {
      "appointmentRescheduleKey": this.rescheduleDetails["RescheduleKey"],
      "appointmentDate": CommonMethods.changeDateFormatDDMMYYYY(formDataValues.appointmentDate),
      "slotTime":slotObj.SlotTime,
      "slotId":+slotObj.SlotId,
      "modifiedIp":"",
      "hospitalId": +this.selectedHospital
    }

    this.loadingFlag = true;
    this.hcService.getHCAppointmentsReschedule(payload) 
    .subscribe((res: any) => {
      this.loadingFlag = false;
        this.messageService.showSuccess(res.errorMsg);
        this.closeConfirmModal();
        this.callCenterService.afterCompleteOperationKnowTheStatus({"callStatusId":"16",
        "callStatusName":"Rescheduling",
        "isOperationDone":true,
        "statusMessage": "Reschedule HC Appointment Successfully."});
        this.getAppointmentsHistoryOnMobileNumberFromAskApollo(this.currentMobileNumber);
        this.rescheduleAppointmentForm['appointmentSlot'] = "";
        this.rescheduleAppointmentForm['appointmentDate'] = "";
        this.rescheduleAppointmentForm['statusRemarks'] = "";
        debugger
        this.UpdateCallStatusDetails();
    }, error => {
      this.loadingFlag = false;
      this.messageService.showErrorMessage("Unable to reschedule Appt, An error occur while rescheduling Appt.");
    })
  }

  cancelRemarksInput = "";
  CancelAppointment(){
    let formDataValues =this.rescheduleAppointmentForm.value;        
    let payload = {
      "appointmentCancelKey": this.rescheduleDetails["CancelKey"],
      "IsPersonalizedHCPackage": false,
      "UserId": 11,//localStorage.getItem("username"),
      "modifiedIP":"",
      "CancelComments":this.cancelRemarksInput,
      "HospitalId": +this.selectedHospital
    }

    this.loadingFlag = true;
    this.hcService.getHCAppointmentsCancel(payload) 
    .subscribe((res: any) => {
      this.loadingFlag = false;
        this.messageService.showSuccess(res.StatusMsg);
        this.closeConfirmModal();
        this.callCenterService.afterCompleteOperationKnowTheStatus({"callStatusId":"23",
        "callStatusName":"Cancel Appointment",
        "isOperationDone":true,
        "statusMessage": "Cancel HC Appointment Successfully."});
        this.getAppointmentsHistoryOnMobileNumberFromAskApollo(this.currentMobileNumber);
        this.cancelRemarksInput ="";
        this.UpdateCallStatusDetails();
    }, error => {
      this.loadingFlag = false;
      this.messageService.showErrorMessage("Unable to cancel Appt, An error occur while cancel Appt.");
    })
  }

  pastApptHistory = [];
  futureApptHistory = [];
  getAppointmentsHistoryOnMobileNumberFromAskApollo(mobileNo) {
    this.pastApptHistory=[];
    this.futureApptHistory=[];
    let payload = {
      "mobilenumber":mobileNo
    }
    this.isLoading= true;
    this.hcService.getHCAppointmentsHistoryOnMobileNumber(payload)
      .subscribe((res: any) => {
        this.pastApptHistory = res.lstPastAppointmentDetails;
        this.futureApptHistory = res.lstFutureAppointmentDetails;
        this.isLoading= false;
      }, error => {
        this.isLoading= false;
        this.messageService.showErrorMessage("Unable to retrieve appointment history data from server ");
      })
  }

  UpdateCallStatusDetails() {    
    //this.resetPkgEnquiryForm = false;
    let time = "";
    let date = "";
    let payload = {
      "AutoId": +localStorage.getItem("currentCallerStatusAutoId"),
      "CallStatus": this.isCancel ? "23": "16" ,
      "CallSubStatus": this.isCancel ? "Cancel" :"Reschedule",
      "Remarks": this.isCancel ? this.cancelRemarksInput : this.rescheduleAppointmentForm['statusRemarks'] ,
      "CallbackRequestDate": date,
      "CallbackRequestTime": time,
      "IsActivityLead": localStorage.getItem("IsActivityLead") == 'true' ? true : false
    }
    this.callCenterService.UpdateCallStatusDetails(payload)
      .subscribe((res: any) => {     
      }, error => {                
      })

  }


}
